import { Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";

interface DataGridFilterButtonProps {
  activeFiltersCount?: number;
  onClick: () => void;
}

export const DataGridFilterButton = ({ activeFiltersCount = 0, onClick }: DataGridFilterButtonProps) => {
  return (
    <Button icon={<FilterOutlined />} onClick={onClick} size="small">
      فیلترها
      {activeFiltersCount > 0 && ` (${activeFiltersCount})`}
    </Button>
  );
};
